import {Breadcrumbs, type BreadcrumbsProps, Typography} from "@mui/material";
import ArrowIcon from '../../icons/svg/ChevronIcon.svg?react'
import {Skeleton} from "@mui/material";
export type BreadcrumbSeparatorType = 'slash' | 'chevron';

const breadcrumbSeparators: Record<BreadcrumbSeparatorType, React.ReactNode> = {
    slash: '/',
    chevron: <ArrowIcon fontSize="large"/>,
};

interface Props extends BreadcrumbsProps {
    contents: string[];
    loading?: boolean;
    separatorType?: BreadcrumbSeparatorType;
}

export function CustomBreadcrumbs({
                                      contents,
                                      loading,
                                      separatorType = 'chevron',
                                      ...props
                                  }: Props) {
    return (
        <Breadcrumbs
            separator={breadcrumbSeparators[separatorType]}
            aria-label="breadcrumb"
            {...props}
        >
            {contents.filter(content => content).map(content => loading ?
                <Skeleton key={content} width={200} height={32}/> :
                <Typography key={content} variant="h5" sx={{color: 'text.primary'}}>
                    {content}
                </Typography>)}
        </Breadcrumbs>
    );
}
